import { docReady } from "../utilities";
import Favourites from '../libraries/Favourites';
import { load } from "@shopify/theme-sections";

import '../sections/collection-filters';

load('collection-filters');

docReady(function() {
    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }
    if (Shopify.queryParams.sort_by) {
        const pos = document.getElementsByClassName('collection__content')[0].getBoundingClientRect();
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }
        window.scrollTo(0, parseInt(pos.top));

    }
    const sortingSelectors = document.getElementsByClassName('collection-sorting__select');
    if (sortingSelectors.length > 0) {
        [].forEach.call(sortingSelectors, function(sortingSelector) {
            sortingSelector.addEventListener('change', function(event) {
                Shopify.queryParams.sort_by = event.target.value;
                const URLparams = Object.keys(Shopify.queryParams).map(function(k) {
                    return encodeURIComponent(k) + '=' + encodeURIComponent(Shopify.queryParams[k])
                }).join('&')
                location.search = URLparams.replace(/\+/g, '%20');
            });
        });
    }

    Favourites.init();
    Favourites.initButtons();
});
